import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface UseEnduserObservationsOptions {
  limit?: number;
  enabled?: boolean;
}

export const useEnduserObservations = (options: UseEnduserObservationsOptions = {}) => {
  const { limit = 500, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "enduser_observations",
    method: "getSome",
    request: {
      filter: {},
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled,
  });

  const allObservations = query.data ?? [];

  const sortedObservations = [...allObservations].sort((a, b) => {
    const aTime = new Date(a.timestamp).getTime();
    const bTime = new Date(b.timestamp).getTime();
    return bTime - aTime;
  });

  return {
    ...query,
    observations: sortedObservations,
  };
};
